import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ModalService } from '../modal.service';
import { Subscription } from 'rxjs';
import { ToastService } from 'src/app/components/toast/toast.service';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';
import { JioTvPlanservice } from 'src/app/pages/jiotvplans/jiotvplans.service';

@Component({
    selector: 'app-configure-discount-modal',
    templateUrl: './configure-discount-modal.component.html',
    styleUrls: ['./configure-discount-modal.component.scss'],
})
export class ConfigureDiscountModalComponent {
    jiotvplansSubscription$?: Subscription;
    callback!: (result: any) => void;
    data: any;
    chargeitConfig: any = null;
    price: number | null = null;
    modalInput!: {
        data: any;
        callback: (result: any) => void;
    };
    discountForm!: FormGroup;
    basedOnData: any = {
        label: '--Based On--',
        options: [
            { label: '--Based On--', value: '' },
            { label: 'Cycle', value: 'cycle' },
        ],
    };
    typeData: any = {
        label: '--Type--',
        options: [
            { label: '--Type--', value: '' },
            { label: 'Option 1', value: 'Option 1' },
            { label: 'Option 2', value: 'Option 2' },
        ],
    };
    operatorData: any = {
        label: '--Operator--',
        options: [
            { label: '--Operator--', value: '' },
            { label: 'Option 1', value: 'Option 1' },
            { label: 'Option 2', value: 'Option 2' },
        ],
    };

    startDate: any;
    endDate: any;
    startTime: any;
    endTime: any;
    minStartDate: string = '';
    minEndDate: any = '';
    maxStartDate: any = '';
    discountValueText = '';
    constructor(
        private JiotvPlans: JioTvPlanservice,
        private toast: ToastService,
        private modal: ModalService,
        private spinner: SpinnerService
    ) {}

    ngOnInit(): void {
        // Rule Expiry date: min selectable = current date + 1
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        this.minStartDate = tomorrow.toISOString().split('T')[0]; // yyyy-MM-dd for input min

        this.discountForm = new FormGroup({
            basedOn: new FormControl('', []),
            operator: new FormControl('', []),
            type: new FormControl('', []),
            count: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
            discountValue: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
            expirationDate: new FormControl('', []),
        });

        this.discountForm.get('discountValue')?.valueChanges.subscribe((value) => {
            this.discountValueText = value;
        });

        this.discountForm.get('type')?.valueChanges.subscribe(() => {
            this.updateDiscountValueValidators();
        });

        const inputData = this.modalInput?.data ?? this.data;
        console.log('INPUT DATA RECEIVED', inputData);
        if (inputData) {
            this.chargeitConfig = inputData['chargeitConfig'] ?? null;
            this.price = inputData['price'] != null ? Number(inputData['price']) : null;
            const rule = this.chargeitConfig?.discountRules?.[0];
            const formPatch: Record<string, any> = {};
            if (rule) {
                const condition = rule.condition?.[0];
                formPatch['basedOn'] = condition?.fact ?? inputData['basedOn'] ?? '';
                formPatch['operator'] = condition?.operator ?? inputData['operator'] ?? '';
                formPatch['type'] = rule.event?.type ?? inputData['type'] ?? '';
                formPatch['count'] = condition?.value ?? inputData['count'] ?? '';
                formPatch['discountValue'] = rule.event?.params?.discountValue ?? inputData['discountValue'] ?? '';
                const rawExpiry =
                    rule.expirationDate ?? rule.event?.expirationDate ?? inputData['expirationDate'] ?? '';
                formPatch['expirationDate'] = this.toDateInputValue(rawExpiry);
            } else {
                Object.assign(formPatch, inputData);
                delete formPatch['chargeitConfig'];
                delete formPatch['price'];
                if (formPatch['expirationDate']) {
                    formPatch['expirationDate'] = this.toDateInputValue(formPatch['expirationDate']);
                }
            }
            if (Object.keys(formPatch).length) {
                this.discountForm.patchValue(formPatch);
            }
            const basedOnVal = formPatch['basedOn'] ?? inputData['basedOn'];
            const operatorVal = formPatch['operator'] ?? inputData['operator'];
            const typeVal = formPatch['type'] ?? inputData['type'];
            this.updateDropdownLabel(this.basedOnData, basedOnVal);
            this.updateDropdownLabel(this.operatorData, operatorVal);
            this.updateDropdownLabel(this.typeData, typeVal);
        }

        this.updateDiscountValueValidators();

        this.discountForm.valueChanges.subscribe(() => {
            this.discountForm.markAsDirty();
        });

        this.jiotvplansSubscription$ = this.JiotvPlans.jiotvplans$.subscribe((params: any) => {
            if (params) {
                switch (params.type) {
                    case 'CHARGEIT_DROPDOWN_GET_SUCCESSFUL':
                        /*Charge It dropdown */
                        let basedOn = params.data?.data?.disContinueEnums;
                        let operators = params.data?.data?.operators;
                        let type = params.data?.data?.events;

                        console.log('Charge It Dropdown Data', params.data, basedOn, operators, type);

                        /* Based On Dropdown */
                        // let basedOnData = basedOn.map((basedOn: any) => {
                        //     return { label: basedOn, value: basedOn };
                        // });
                        // basedOnData.unshift({ label: '--Based On--', value: '' });
                        // this.basedOnData = { label: '--Based On--', options: basedOnData };
                        // if (this.discountForm.get('basedOn')?.value) {
                        //     const id = this.discountForm.get('basedOn')?.value;
                        //     const result = basedOnData.find((item: any) => item.value === id);
                        //     console.log('BASED ON', basedOn, result);
                        //     this.basedOnData = {
                        //         label: result?.label ?? id ?? '--Based On--',
                        //         options: basedOnData,
                        //     };
                        // }

                        /*Operators Dropdown */
                        let operatorData = operators.map((operators: any) => {
                            return { label: operators, value: operators };
                        });
                        operatorData.unshift({ label: '--Operators--', value: '' });
                        this.operatorData = { label: '--Operators--', options: operatorData };
                        if (this.discountForm.get('operator')?.value) {
                            const id = this.discountForm.get('operator')?.value;
                            const result1 = operatorData.find((item: any) => item.value === id);
                            console.log('Operator', operators, result1);
                            this.operatorData = {
                                label: result1?.label ?? id ?? '--Operators--',
                                options: operatorData,
                            };
                        }

                        /*Type Dropdown */
                        let typeData = type.map((type: any) => {
                            return { label: type, value: type };
                        });
                        typeData.unshift({ label: '--Type--', value: '' });
                        this.typeData = { label: '--Type--', options: typeData };
                        if (this.discountForm.get('type')?.value) {
                            const id = this.discountForm.get('type')?.value;
                            const result2 = typeData.find((item: any) => item.value === id);
                            console.log('TYPE', type, result2);
                            this.typeData = {
                                label: result2?.label ?? id ?? '--Type--',
                                options: typeData,
                            };
                        }

                        break;
                }
            }
        });

        this.JiotvPlans.getAllChargeItDropdownData();
    }

    /** Normalize any date string to yyyy-MM-dd for native date input display */
    private toDateInputValue(dateStr: string | undefined): string {
        if (!dateStr) return '';
        // Support "YYYY-MM-DD HH:mm:ss" and ISO strings; native date input needs yyyy-MM-dd
        const normalized = String(dateStr).trim().replace(' ', 'T');
        const d = new Date(normalized);
        if (isNaN(d.getTime())) return '';
        const y = d.getFullYear();
        const M = String(d.getMonth() + 1).padStart(2, '0');
        const D = String(d.getDate()).padStart(2, '0');
        return `${y}-${M}-${D}`;
    }

    private updateDropdownLabel(dropdown: any, value: any) {
        if (!value) return;

        const match = dropdown.options.find((opt: any) => opt.value === value);
        if (match) {
            dropdown.label = match.label;
        }
    }

    get summaryOperatorDisplay(): string {
        const op = this.discountForm?.get('operator')?.value;
        const map: Record<string, string> = {
            lessThan: 'less than',
            lessThanInclusive: 'less than or equal to',
            greaterThan: 'greater than',
            greaterThanInclusive: 'greater than or equal to',
        };
        return (op && map[op]) || 'less than';
    }

    get summaryCount(): string | number {
        return this.discountForm?.get('count')?.value ?? '';
    }

    get summaryDiscountSymbol(): string {
        const type = this.discountForm?.get('type')?.value;
        return type === 'discountPercentage' ? '%' : '₹';
    }

    get summaryExpiryDisplay(): string {
        const d = this.discountForm?.get('expirationDate')?.value;
        if (!d) return '';
        try {
            const date = new Date(d);
            return isNaN(date.getTime())
                ? d
                : date.toLocaleDateString('en-IN', {
                      weekday: 'short',
                      year: 'numeric',
                      month: 'short',
                      day: 'numeric',
                  });
        } catch {
            return String(d);
        }
    }

    private updateDiscountValueValidators(): void {
        const discountValueControl = this.discountForm.get('discountValue');
        if (!discountValueControl) return;

        const type = this.discountForm.get('type')?.value;
        const baseValidators = [Validators.required, Validators.pattern('^[0-9]*$')];

        if (type === 'discountPercentage') {
            discountValueControl.setValidators([...baseValidators, Validators.min(0), Validators.max(100)]);
        } else if (type === 'discountFixed') {
            const validators = [...baseValidators, Validators.min(0)];
            if (this.price != null) {
                validators.push(Validators.max(this.price));
            }
            discountValueControl.setValidators(validators);
        } else {
            discountValueControl.setValidators(baseValidators);
        }
        discountValueControl.updateValueAndValidity();
    }

    validateNumericInput(field: string) {
        let value = this.discountForm.get(field)?.value;
        if (!/^[\d\s]*$/.test(value)) {
            // Allow only numbers and spaces
            this.discountForm.get(field)?.setValue(value.replace(/[^\d\s]/g, ''));
        }
    }

    setDate(event: any) {
        console.log('date:', event.target.value);
        const value = event.target.value;
        this.discountForm.get('expirationDate')?.setValue(value);
        this.minEndDate = value;
    }

    selectBasedOn(event: any) {
        console.log(event);
        const basedOn = this.discountForm.get('basedOn') as FormControl;
        basedOn.setValue(event.data);
        this.discountForm.markAsDirty();
    }

    selectOperator(event: any) {
        console.log(event);
        const operator = this.discountForm.get('operator') as FormControl;
        operator.setValue(event.data);
        this.discountForm.markAsDirty();
    }

    selectType(event: any) {
        console.log(event);
        const type = this.discountForm.get('type') as FormControl;
        type.setValue(event.data);
        this.discountForm.markAsDirty();
    }

    cancel() {
        if (this.discountForm.dirty) {
            this.toast.showToast('You Have Unsaved Changes. Please Save Before Closing.', 'error');
            return;
        }

        this.modal.closeModal();
    }

    save() {
        const discountValueControl = this.discountForm.get('discountValue');
        if (this.discountForm.invalid) {
            if (discountValueControl?.errors?.['min'] || discountValueControl?.errors?.['max']) {
                const type = this.discountForm.get('type')?.value;
                if (type === 'discountPercentage') {
                    this.toast.showToast('Discount percentage must be between 0 and 100.', 'error');
                } else if (type === 'discountFixed') {
                    this.toast.showToast(
                        this.price != null
                            ? `Discount value must not be greater than price (${this.price}).`
                            : 'Price is required for fixed discount validation.',
                        'error'
                    );
                } else {
                    this.toast.showToast('Please Fill All Required Fields', 'error');
                }
            } else {
                this.toast.showToast('Please Fill All Required Fields', 'error');
            }
            return;
        }

        let discountData = this.discountForm.value;
        const type = discountData.type;
        const value = Number(discountData.discountValue);

        if (type === 'discountPercentage') {
            if (value < 0 || value > 100) {
                this.toast.showToast('Discount percentage must be between 0 and 100.', 'error');
                return;
            }
        } else if (type === 'discountFixed') {
            if (this.price == null) {
                this.toast.showToast('Price is required for fixed discount validation.', 'error');
                return;
            }
            if (value < 0 || value > this.price) {
                this.toast.showToast(`Discount value must not be greater than price (${this.price}).`, 'error');
                return;
            }
        }

        const expirationDate = this.discountForm.get('expirationDate')?.value;
        if (expirationDate && this.minStartDate && expirationDate < this.minStartDate) {
            this.toast.showToast('Rule Expiry date must be at least tomorrow.', 'error');
            return;
        }

        // Format expirationDate as YYYY-MM-DD HH:mm:ss in payload
        const rawDate = discountData.expirationDate;
        if (rawDate) {
            const d = new Date(rawDate);
            if (!isNaN(d.getTime())) {
                const y = d.getFullYear();
                const M = String(d.getMonth() + 1).padStart(2, '0');
                const D = String(d.getDate()).padStart(2, '0');
                const h = String(d.getHours()).padStart(2, '0');
                const m = String(d.getMinutes()).padStart(2, '0');
                const s = String(d.getSeconds()).padStart(2, '0');
                discountData = { ...discountData, expirationDate: `${y}-${M}-${D} ${h}:${m}:${s}` };
            }
        }

        // SEND DATA BACK TO PARENT
        this.modalInput?.callback?.(discountData);

        this.toast.showToast('Discount Saved Successfully', 'success');
        this.modal.closeModal();
    }
}
